import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap"
import TreeView from "../../../Components/TreeView/TreeView";
import { useEffect, useState } from "react";
import { getAll, create, deleteCategory, update } from "../../store/api/eventCategoriesApi";
import { setErrorDialog, translateError } from "../../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";
/**
 * @typedef {object} ModalData
 * @property {boolean} show,
 * @property {function} setSelectedCategory
 */
/**
 * @component
 * @param {object} props 
 * @param {ModalData} props.modalData
 * @param {(modalData: ModalData)=> void} props.setModalData
 * @returns
 */
const ModalEventCategories = ({ setModalData, modalData }) => {
    const dispatch = useDispatch();
    const [nodes, setNodes] = useState(null);
    const close = () => {
        setModalData({ show: false });
    }
    const createCat = async (cat) => {
        const result = await create(cat);
        if (result.Message || result.message) {
            const err = translateError(result.Message || result.message);
            setErrorDialog(dispatch, err, "ایجاد دسته بندی");
            return false;
        }
        else if (result.Data) {
            setErrorDialog(dispatch, "success", "ایجاد دسته بندی", 5000);
            return Number(result.Data);
        }

    }
    const updateCat = (cat) => {
        const onUpdate = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ویرایش دسته بندی");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "ویرایش دسته بندی", 5000);
            }
        }
        update(cat, onUpdate);

    }
    const deleteCat = (catId) => {
        const onDelete = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف دسته بندی");
            }
            else if (res.Data) {
                setErrorDialog(dispatch, "success", "حذف دسته بندی", 5000);
            }
        }
        deleteCategory(catId, onDelete);
    }

    useEffect(() => {
        if (modalData.show) {
            const onSet = (res) => {
                if (res.Data) {
                    setNodes(res.Data[0]);
                }
            }
            getAll(0, onSet);
        }
    }, [modalData.show])
    if (!modalData.show) {
        return null;
    }
    return (
        <Modal show={modalData.show}>
            <Modal.Header className="headerStyle">
                <span>
                    دسته بندی رویدادها
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle scThin" style={{maxHeight:"70vh", overflow:"auto"}}>
                {nodes &&
                    <TreeView nodes={nodes} setNodes={setNodes} onAddNode={createCat} onRemoveNode={deleteCat} onEditNode={updateCat} />}
            </Modal.Body>
        </Modal>
    )
}
export default ModalEventCategories;